import { MouseEvent, ChangeEvent } from 'react'
import type { Book, SortConfig, BookField } from '@/types'
import { formatAuthors } from '../../formattingUtils'

interface BookWithProfile extends Book {
    profiles?: {
        full_name?: string
    }
}

interface CompactListViewProps {
    books: BookWithProfile[]
    selectedIds: Set<string>
    allFilteredSelected: boolean
    toggleBookSelection: (e: MouseEvent | ChangeEvent, bookId: string) => void
    onBookClick: (book: BookWithProfile) => void
    initiateDelete: (e: MouseEvent, bookId: string) => void
    deselectAll: () => void
    selectAllFiltered: () => void
    isBiblioverso: boolean
    isSharedView: boolean
    sortConfig: SortConfig
    handleSort: (key: BookField) => void
}

export default function CompactListView({
    books,
    selectedIds,
    allFilteredSelected,
    toggleBookSelection,
    onBookClick,
    initiateDelete,
    deselectAll,
    selectAllFiltered,
    isBiblioverso,
    isSharedView,
    sortConfig,
    handleSort,
}: Readonly<CompactListViewProps>) {
    return (
        <div className="books-table-wrapper animate-fade-in">
            <table className="books-table compact-table">
                <thead>
                    <tr>
                        <th className="th-checkbox">
                            <input
                                type="checkbox"
                                checked={allFilteredSelected}
                                onChange={() => (allFilteredSelected ? deselectAll() : selectAllFiltered())}
                            />
                        </th>
                        <th
                            className={`sortable-th ${sortConfig.key === 'title' ? 'active' : ''}`}
                            onClick={() => handleSort('title')}
                        >
                            Título {sortConfig.key === 'title' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                        </th>
                        <th
                            className={`sortable-th ${sortConfig.key === 'author' ? 'active' : ''}`}
                            onClick={() => handleSort('author')}
                        >
                            Autor {sortConfig.key === 'author' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                        </th>
                        {isBiblioverso && (
                            <th
                                className={`sortable-th ${(sortConfig.key as string) === 'owner' ? 'active' : ''}`}
                                onClick={() => handleSort('owner' as BookField)}
                            >
                                Biblionauta {(sortConfig.key as string) === 'owner' && (sortConfig.direction === 'asc' ? '↑' : '↓')}
                            </th>
                        )}
                        <th className="th-actions"></th>
                    </tr>
                </thead>
                <tbody>
                    {books.map((book) => {
                        const isSelected = selectedIds.has(book.id)
                        return (
                            <tr key={book.id} className={`table-row clickable ${isSelected ? 'is-selected' : ''}`} onClick={() => onBookClick(book)} data-testid={`book-card-${book.title}`}>
                                <td className="td-checkbox" onClick={(e) => e.stopPropagation()}>
                                    <input
                                        type="checkbox"
                                        checked={isSelected}
                                        onChange={(e) => toggleBookSelection(e, book.id)}
                                        onClick={(e) => e.stopPropagation()}
                                    />
                                </td>
                                <td className="td-title">{book.title}</td>
                                <td className="td-author">{formatAuthors(book.author)}</td>
                                {isBiblioverso && <td className="td-owner">{book.profiles?.full_name || 'Mi Biblioteca'}</td>}
                                <td className="td-actions" onClick={(e) => e.stopPropagation()}>
                                    {!isBiblioverso && !isSharedView && (
                                        <button onClick={(e) => initiateDelete(e, book.id)} className="table-delete" data-testid="delete-book-button">
                                            🗑️
                                        </button>
                                    )}
                                </td>
                            </tr>
                        )
                    })}
                </tbody>
            </table>
        </div>
    )
}
